<template>
  <transition name="fade">
    <div v-if="customerId && !customerIsSignedUpForSmsMarketing" class="viber-form account-viber-section" id="userViber">
    <div class="col-12 viber-form-container">
      <div class="customer-block-header">
        <div class="row">
          <div class="col-12 col-lg-9">
            <div class="viber-form-head">
              <div class="viber-form-head-title">{{ t('viber.form.title') }}</div>
              <span class="viber-form-body-text">
                  {{ t('viber.form.text') }}
              </span>
            </div>
          </div>
          <div class="col-3 viber-form-body">
            <img src="/ui/main/img/viber-tel-asset.png">
          </div>
        </div>
      </div>
        <div class="viber-form-body-form" id="submitViber">
          <div class="d-flex" style="flex-wrap: wrap;">
            <div class="custom-dropdown col-12 col-lg-4">
              <div class="dropdown-selected" @click="toggleDropdown">
                <span :class="`fi fi-${selectedCountry.toLowerCase()}`"></span>
                +{{ availableCountryCodes[selectedCountry] }}
              </div>
              <ul v-if="showDropdown" class="dropdown-options">
                <li
                  v-for="(code, country) in availableCountryCodes"
                  :key="country"
                  @click="selectCountry(country)"
                >
                  <span :class="`fi fi-${country.toLowerCase()}`"></span>
                  +{{ code }}
                </li>
              </ul>
            </div>

            <input
              class="viber-form-body-form-input col-12 col-lg-8"
              @click="closeDropdown"
              :placeholder="placeholderText"
              type="text"
              v-model="phone"
            />
          </div>
          <button
            class="col-12 col-lg-4 viber-form-body-form-button"
            v-on:click="formSubmit()"
            type="button"
            :aria-label="t('entry.lbl')"
          >
            <span v-show="!isLoading">{{ t('entry.lbl') }}</span>
            <span v-if="isLoading" class="loader"></span>
          </button>
        </div>
      <div class="viber-form-footer">
        <!-- <div class="viber-form-footer-checkbox">
          <input
            id="viberCheckBox"
            type="checkbox"
            class="viber-form-footer-checkbox-input"
            name="viberCheckBox"
            :checked="addToViberChecked"
            disabled
          >
          <label for="viberCheckBox" class="viber-form-footer-checkbox-label">
            <span class="viber-form-footer-checkbox-label-text">
              {{ t('viber.checkbox.agree.label') }}
            </span>
          </label>
        </div> -->
        <div v-if="showError && error" class="viber-form-footer-error alert alert-error">{{ error }}</div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ViberForm',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    customerId: {
      type: Number,
      default: null
    },
    availableCountryCodes: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formPosted: false,
      showError: false,
      error: '',
      phone: '',
      selectedCountry: Object.keys(this.availableCountryCodes)[0] || 'GR',
      showDropdown: false,
      addToViberChecked: true,
      placeholderText: this.t('viber.phone.placeholder'),
      customerIsSignedUpForSmsMarketing: true,
      isLoading: false
    }
  },
  async created () {
    if (this.placeholder) {
      this.placeholderText = this.placeholder
    }
    await axios
      .get('/api/customer/getCustomerIsSignedUpViber')
      .then((response) => {
        this.customerIsSignedUpForSmsMarketing = response.data.isSignedUpViber
      })
      .catch(() => {
        this.customerIsSignedUpForSmsMarketing = true
      })
  },
  computed: {
    fullPhoneNumber () {
      const code = this.availableCountryCodes[this.selectedCountry] || ''
      const number = this.phone.replace(/\D/g, '')
      return `+${code}${number}`
    }
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },
    closeDropdown () {
      this.showDropdown = false
    },
    selectCountry (country) {
      this.selectedCountry = country
      this.showDropdown = false
    },
    async formSubmit () {
      this.closeDropdown()
      try {
        const res = await this.validatePhone()
        if (res.data.success !== true) {
          this.error = this.t('viber.phone.error')
          this.showError = true
          return
        }
        this.postData()
      } catch (err) {
        this.error = this.t('viber.phone.error')
        this.showError = true
      }
    },
    validatePhone () {
      return axios.post(`/api/phoneChecker/checkNumber`, {
        phone: this.fullPhoneNumber
      })
    },
    postData () {
      this.isLoading = true
      axios
        .post('/api/customer/setViberPhone', {
          addToViber: true,
          phone: this.fullPhoneNumber
        })
        .then((response) => {
          const responseMessage = response.data.detail
          this.$toasted.success(responseMessage)
          this.formPosted = true
          this.customerIsSignedUpForSmsMarketing = true
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.phone
            this.showError = true
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to { opacity: 0 }
.fade-leave, .fade-enter-to { opacity: 1 }
.fade-enter-active, .fade-leave-active { transition: opacity 1000ms }

.loader {
  position: relative;
  display: grid;
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 26px;
  height: 26px;
  animation: spin 2s linear infinite;
  justify-items: center;
  align-items: center;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.viber-form {
  position: relative;
  display: grid;
  width: 100%;
  max-width: 550px;
  padding: 0;
}

.custom-dropdown {
  position: relative;
  cursor: pointer;
  user-select: none;
}

.dropdown-selected {
  padding: 8px 6px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 0px;
  color: #000;
}

.dropdown-options {
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 999;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-options li {
  padding: 8px 6px;
  display: flex;
  align-items: center;
  gap: 0px;
  color: #000;
}

.dropdown-options li:hover {
  background-color: #f0f0f0;
}
</style>
